import React, { useState, useRef, useEffect, useContext } from "react";
import { useDrop } from "react-dnd";
import { ItemTypes } from "./types";
import BusinessIcon from "@mui/icons-material/Business";
import Person from "./Person";
import GoogleMapReact from "google-map-react";
import RoomIcon from "@mui/icons-material/Room";
import Marker from "shared/components/UIElements/Marker";
import CustomSelect from "shared/components/FormElements/Select";
import { subtractSecondsFromDate } from "shared/util/time";
import { StoreContext } from "shared/context/store-context";
import { AuthContext } from "shared/context/auth-context";
import { VALIDATOR_REQUIRE, VALIDATOR_NONE } from "shared/util/validators";
import { useForm } from "shared/hooks/form-hook";
import { CheckTimeString } from "shared/util/time";
import { useHttpClient } from "shared/hooks/http-hook";
import "./dragger.css";

const Vehicle = ({
  id,
  school,
  users,
  name,
  destinationTime,
  driver,
  onDrop,
  distances,
  otherServices,
  transferType,
  onPersonUp,
  onPersonDown,
  onOptimize,
  onDeleteService,
  onSaveResult,
  onChangeName,
  onPersonToOtherService,
}) => {
  const store = useContext(StoreContext);

  const auth = useContext(AuthContext);

  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const mapREF = useRef(null);
  const mapsREF = useRef(null);
  const polylinesREF = useRef([]);
  const polyLineLabelsREF = useRef([]);
  const optimizedREF = useRef(false);
  const [calculatedUsers, setCalculatedUsers] = useState([]);
  const [airportInfo, setAirportInfo] = useState({});
  const [transferName, setTransferName] = useState(name);

  const polygonDistances = useRef([]);

  const [{ canDrop, isOver }, drop] = useDrop({
    accept: ItemTypes.PASSENGER,
    drop: (item) => onDrop(item.id, id),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    type: ItemTypes.VEHICLE,
  });

  const isActive = canDrop && isOver;

  const handleApiLoaded = (map, maps) => {
    mapREF.current = map;
    mapsREF.current = maps;
    drawPolylines();
  };

  const drawTheOtherService = (serviceId) => {
    const service = otherServices.find((service) => service.id === serviceId);
    if (!service) {
      return;
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const drawPolylines = async () => {
    if (!mapREF.current || !mapsREF.current) {
      return;
    }

    for (var k = 0; k < polylinesREF.current.length; k++) {
      polylinesREF.current[k].setMap(null);
    }

    for (var l = 0; l < polyLineLabelsREF.current.length; l++) {
      polyLineLabelsREF.current[l].setMap(null);
    }

    const currentPolylines = [];
    const currentPeople = [];
    for (var i = 0; i < users.length; i++) {
      // eslint-disable-next-line no-loop-func
      let person = users[i];
      let nextPersonId = null;
      if (transferType.toString() === "100") {
        if (i < users.length - 1) {
          nextPersonId = users[i + 1].id;
        } else {
          nextPersonId = school.id;
        }
      }

      if (transferType.toString() === "200") {
        if (i === 0) {
          person = { id: school.id, name: school.name, lat: school.location.lat, lng: school.location.lng };
          nextPersonId = users[i].id;
        } else {
          person = users[i - 1];
          nextPersonId = users[i].id;
        }
      }

      const currentDistance = distances.find((distance) => distance.from === person.id && distance.to === nextPersonId);

      // const currentPolygons = currentDistance.data.steps.map((step) => {
      //   return [
      //     { lat: step.start_location.lat, lng: step.start_location.lng },
      //     { lat: step.end_location.lat, lng: step.end_location.lng },
      //   ];
      // }); //emrah

      if (!currentDistance?.data?.distance?.text) {
        alert(
          "Hata: " +
            person.name +
            " sonrasındaki yol için Google haritalardan yol çıkarılamadı. Okları kullanarak işlemlere devam ediniz."
        );
        continue;
      }
      const currentDistanceDistance = currentDistance.data.distance.text;
      const currentDistanceDuration = currentDistance.data.duration.text.replace("mins", "dk").replace("min", "dk");
      const currentDistanceDurationValue = currentDistance.data.duration.value;
      const currentDistanceDistanceValue = currentDistance.data.distance.value;

      const currentDistanceLabel = currentDistanceDistance + " (" + currentDistanceDuration + ")";

      let currentPolygonDistance = polygonDistances.current.find(
        (distance) => distance.from === person.id && distance.to === nextPersonId
      )?.distance;
      if (!currentPolygonDistance) {
        let stopsToAsk = users.filter((stop) => stop.id === person.id || stop.id === nextPersonId);
        stopsToAsk = stopsToAsk.map((stop) => {
          stop.location = { lat: stop.lat, lng: stop.lng };
          return stop;
        });
        if (i == users.length - 1 && transferType.toString() === "100") {
          stopsToAsk = users.filter((stop) => stop.id === person.id);
          stopsToAsk = stopsToAsk.map((stop) => {
            stop.location = { lat: stop.lat, lng: stop.lng };
            return stop;
          });
          stopsToAsk.push(school);
        }
        const data = {
          origin: school,
          stops: stopsToAsk,
          type: "100",
        };
        try {
          const response = await sendRequest(
            `${process.env.REACT_APP_BACKEND_URL}/automated/getdistances`,
            "POST",
            JSON.stringify(data),
            {
              "Content-Type": "application/json",
              Authorization: "Bearer " + auth.token,
            }
          );
          if (response.distances) {
            currentPolygonDistance = response.distances.find(
              (distance) => distance.from === person.id && distance.to === nextPersonId
            ).distance;
            polygonDistances.current.push({ from: person.id, to: nextPersonId, distance: currentPolygonDistance });
          }
        } catch (err) {
          alert(err);
        }
      }
      if (currentPolygonDistance) {
        const currentPolygons = currentPolygonDistance.data.steps.map((step) => {
          return [
            { lat: step.start_location.lat, lng: step.start_location.lng },
            { lat: step.end_location.lat, lng: step.end_location.lng },
          ];
        });

        //SIMDILIK
        // for (var j = 0; j < currentPolygons.length; j++) {
        //   var polyline = new mapsREF.current.Polyline({
        //     path: currentPolygons[j],
        //     strokeColor: "#FF0000",
        //     strokeOpacity: 1,
        //     strokeWeight: 2,
        //     fillOpacity: 0,
        //     icons: [
        //       {
        //         icon: { path: mapsREF.current.SymbolPath.FORWARD_CLOSED_ARROW },
        //         offset: "100%",
        //         repeat: "30px",
        //       },
        //     ],
        //   });
        //   currentPolylines.push(polyline);
        //   polyline.setMap(mapREF.current);
        // }
      }

      // const currentDistanceLabelPosition = {
      //   lat: currentPolygons[Math.ceil(currentPolygons.length / 4)][0].lat,
      //   lng: currentPolygons[Math.ceil(currentPolygons.length / 4)][0].lng,
      // };

      //Emrah
      // for (var j = 0; j < currentPolygons.length; j++) {
      //   var polyline = new mapsREF.current.Polyline({
      //     path: currentPolygons[j],
      //     strokeColor: "#FF0000",
      //     strokeOpacity: 1,
      //     strokeWeight: 2,
      //     // fillColor: "#FF0000",
      //     fillOpacity: 0,
      //     icons: [
      //       {
      //         icon: { path: mapsREF.current.SymbolPath.FORWARD_CLOSED_ARROW },
      //         offset: "100%",
      //         repeat: "30px",
      //       },
      //     ],
      //   });

      //   currentPolylines.push(polyline);
      //   polyline.setMap(mapREF.current);
      // }

      if (transferType.toString() === "200" && i === 0) {
        setAirportInfo({
          polylineLabel: currentDistanceLabel,
          distanceLabel: currentDistanceDistance,
          durationLabel: currentDistanceDuration,
          durationValue: currentDistanceDurationValue,
          distanceValue: currentDistanceDistanceValue,
        });
        continue;
      }
      person.polylineLabel = currentDistanceLabel;
      person.durationLabel = currentDistanceDuration;
      person.distanceLabel = currentDistanceDistance;
      person.durationValue = currentDistanceDurationValue;
      person.distanceValue = currentDistanceDistanceValue;
      currentPeople.push(person);
    }

    let pickupbeforeseconds = 0;
    if (transferType === "100") {
      for (var z = currentPeople.length - 1; z >= 0; z--) {
        const airporthourminute = destinationTime.split(" ")[1].substring(0, 5);
        const additionTimeInSeconds = airporthourminute > "07:00" ? 300 : 0;
        pickupbeforeseconds += currentPeople[z].durationValue;
        currentPeople[z].pickupbeforeseconds = pickupbeforeseconds;
        currentPeople[z].pickupTime = subtractSecondsFromDate(
          destinationTime,
          currentPeople[z].pickupbeforeseconds + additionTimeInSeconds
        )
          .split(" ")[4]
          .substring(0, 5);
      }
    }

    if (transferType === 200 && users.length > 0) {
      currentPeople.push(users[users.length - 1]);
    }
    //SIMDILIK
    //polylinesREF.current = currentPolylines;
    //polyLineLabelsREF.current = currentPolylineLabels;
    setCalculatedUsers(currentPeople);

    onSaveResult(currentPeople, formState.inputs.newdriver.value, transferName);

    // const bounds = mapsREF.current.LatLngBounds();
    // mapREF.current.fitBounds(bounds);
  };

  useEffect(() => {
    drawPolylines();
    if (users?.length && !optimizedREF.current) {
      onOptimize();
      optimizedREF.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users]);

  const [formState, inputHandler] = useForm(
    {
      newdriver: { value: store.driverOptions.find((option) => option.value === driver.id).value, isValid: true },
    },
    true
  );

  const [formStateKarsilastirma, inputHandlerKarsilastirma] = useForm(
    {
      otherService: { value: null, isValid: true },
      otherServiceUser: { value: null, isValid: true },
    },
    true
  );

  const personPickupTimeChangeHandler = (event, personId) => {
    const person = calculatedUsers.find((person) => person.id === personId);
    person.pickupTime = event.target.value;
    setCalculatedUsers([...calculatedUsers]);

    //if(CheckTimeString(person.pickupTime))
    //{
    onSaveResult([...calculatedUsers], formState.inputs.newdriver.value, transferName);
    //}
  };

  const transferNameChangeHandler = (event) => {
    setTransferName(event.target.value);
    //if(event.target.value.length > 0)
    // {
    // onSaveResult([...calculatedUsers], formState.inputs.newdriver.value, event.target.value);
    onChangeName(event.target.value);
  };

  const sendToOtherService = () => {
    if (!formStateKarsilastirma.inputs.otherService.value || !formStateKarsilastirma.inputs.otherServiceUser.value) {
      return;
    }

    onDrop(formStateKarsilastirma.inputs.otherServiceUser.value, formStateKarsilastirma.inputs.otherService.value);
  };

  return (
    <div
      ref={drop}
      style={{
        backgroundColor: isActive ? "#fbdd04" : "lightgray",
        padding: "10px",
        margin: "5px",
        marginBottom: "30px",
        borderRadius: "5px",
      }}
    >
      <div style={{ display: "flex", width: "100%", flexDirection: "row" }}>
        <div style={{ width: "25%", display: "flex", flexDirection: "column" }}>
          <input
            style={{
              marginBottom: "10px",
              height: "30px",
              width: "95%",
              borderRadius: "5px",
              paddingLeft: "5px",
              outlineColor: transferName?.length ? "black" : "red",
              borderColor: transferName?.length ? "black" : "red",
            }}
            type="text"
            id={"servicename" + id}
            // onInput={(event) => transferNameChangeHandler(event)}
            defaultValue={transferName}
          />
          <div style={{ marginBottom: "5px" }}>
            Toplam Km:{" "}
            <b>
              {(
                (calculatedUsers.reduce((sum, obj) => sum + (obj?.distanceValue || 0), 0) +
                  (airportInfo?.distanceValue || 0)) /
                1000
              ).toFixed(1)}
            </b>
          </div>
          <div style={{ marginBottom: "10px" }}>
            Toplam Süre:{" "}
            <b>
              {(
                (calculatedUsers.reduce((sum, obj) => sum + (obj?.durationValue || 0), 0) +
                  (airportInfo?.durationValue || 0)) /
                60
              ).toFixed(0)}{" "}
              dk
            </b>
          </div>
          <div style={{ marginRight: "5px" }}>
            <CustomSelect
              options={store.driverOptions}
              id={"newdriver" + id}
              isMulti={false}
              onInput={(id, value) => {
                // onSaveResult(calculatedUsers, value, transferName);
                inputHandler(id, value, true);
              }}
              label="Sürücü"
              errorText="En az 1 sürücü seçiniz."
              initialValue={store.driverOptions.find((option) => option.value === driver.id)}
              initialValid={true}
              validators={[VALIDATOR_REQUIRE()]}
            ></CustomSelect>
          </div>
          <div>
            {transferType.toString() === "200" && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                  alignItems: "center",
                  placeContent: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#aaa",
                    fontWeight: "bold",
                    marginRight: "5px",
                    marginBottom: "10px",
                    borderRadius: "5px",
                    padding: "10px",
                    width: "80%",
                  }}
                >
                  {school.name} - {destinationTime}
                </div>
                <div style={{ marginBottom: "10px" }}>
                  {" "}
                  {">> "}
                  {airportInfo.polylineLabel} {" >>"}
                </div>
              </div>
            )}
            {calculatedUsers.map((person, index) => (
              <div
                style={{ display: "flex", width: "100%", flexDirection: "column", alignItems: "center" }}
                key={"calculatedUsers" + index}
              >
                <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center" }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <button
                      style={{ alignSelf: "flex-start", backgroundColor: "black", padding: "5px", marginBottom: "5px" }}
                      type="button"
                      onClick={() => onPersonUp(person.id)}
                    >
                      <div className="arrow-up"></div>
                    </button>
                    <button
                      style={{ alignSelf: "flex-start", backgroundColor: "black", padding: "5px" }}
                      type="button"
                      onClick={() => onPersonDown(person.id)}
                    >
                      <div className="arrow-down"></div>
                    </button>
                  </div>
                  <Person key={person.id} id={person.id} name={index + 1 + ". " + person.name} />
                  {transferType.toString() === "100" && (
                    <input
                      style={{
                        height: "30px",
                        width: "20%",
                        borderRadius: "5px",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        marginRight: "5px",
                        outlineColor: CheckTimeString(person.pickupTime) ? "black" : "red",
                        borderColor: CheckTimeString(person.pickupTime) ? "black" : "red",
                      }}
                      type="text"
                      key={person.id + "-pickupTime"}
                      id={person.id + "-pickupTime"}
                      onInput={(e) => personPickupTimeChangeHandler(e, person.id)}
                      value={person.pickupTime}
                    />
                  )}
                </div>
                {person.polylineLabel && (
                  <div style={{ marginBottom: "10px" }}>
                    {" "}
                    {">> "}
                    {person?.polylineLabel} {" >>"}
                  </div>
                )}
              </div>
            ))}
            {transferType.toString() === "100" && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#aaa",
                    fontWeight: "bold",
                    marginRight: "5px",
                    marginTop: "10px",
                    borderRadius: "5px",
                    padding: "10px",
                    width: "82%",
                  }}
                >
                  {school.name} - {destinationTime}
                </div>
              </div>
            )}
            <button
              style={{
                alignSelf: "flex-start",
                backgroundColor: "#830000",
                borderColor: "#830000",
                color: "white",
                height: "30px",
                borderRadius: "5px",
                marginBottom: "5px",
                marginTop: "20px",
                padding: "20px",
                display: "flex",
                alignItems: "center",
                fontSize: "large",
              }}
              type="button"
              onClick={onOptimize}
            >
              Optimize et
            </button>

            <button
              style={{
                alignSelf: "flex-end",
                backgroundColor: "#830000",
                borderColor: "#830000",
                color: "white",
                height: "30px",
                borderRadius: "5px",
                marginBottom: "5px",
                marginTop: "50px",
                padding: "10px",
                display: "flex",
                alignItems: "center",
              }}
              type="button"
              onClick={onDeleteService}
            >
              Bu aracı sil
            </button>
          </div>
        </div>

        <div style={{ width: "75%" }}>
          <div style={{ display: "flex", width: "100%", flexDirection: "column" }}>
            <div
              style={{ display: "flex", width: "100%", flexDirection: "row", columnGap: "10px", alignItems: "center" }}
            >
              <div style={{ width: "38%" }}>
                <CustomSelect
                  options={[
                    { value: null, label: "Seçiniz" },
                    ...otherServices.map((service) => {
                      return { value: service.id, label: service.name };
                    }),
                  ]}
                  id="otherService"
                  isMulti={false}
                  onInput={(id, value) => {
                    drawTheOtherService(value);
                    inputHandlerKarsilastirma(id, value, true);
                  }}
                  label="Karşılaştırılacak Servis"
                  validators={[VALIDATOR_NONE()]}
                ></CustomSelect>
              </div>

              <div style={{ width: "38%" }}>
                <CustomSelect
                  options={[
                    { value: null, label: "Seçiniz" },
                    ...users?.map((user) => {
                      return { value: user.id, label: user.name };
                    }),
                  ]}
                  id="otherServiceUser"
                  isMulti={false}
                  onInput={(id, value) => {
                    inputHandlerKarsilastirma(id, value, true);
                  }}
                  label="Yolcu"
                  validators={[VALIDATOR_NONE()]}
                ></CustomSelect>
              </div>

              <div style={{ width: "20%" }}>
                <button
                  style={{
                    alignSelf: "flex-start",
                    backgroundColor: "#830000",
                    borderColor: "#830000",
                    color: "white",
                    height: "30px",
                    borderRadius: "5px",
                    marginLeft: "5px",
                    marginTop: "30px",
                    padding: "20px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "large",
                  }}
                  type="button"
                  onClick={sendToOtherService}
                >
                  Gönder
                </button>
              </div>
            </div>
            <div
              style={{
                height: "42rem",
                width: "100%",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: "AIzaSyAkGOMUyxOH98l6qetwEChfJDgzMrBiDbc",
                  language: "tr",
                  region: "tr",
                  libraries: ["drawing"],
                }}
                yesIWantToUseGoogleMapApiInternals //this is important!
                onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                options={function (maps) {
                  return {
                    mapTypeControl: true,
                    mapTypeId: "roadmap",
                    mapTypeControlOptions: {
                      mapTypeIds: ["roadmap", "satellite"],
                      style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
                      position: maps.ControlPosition.TOP_LEFT,
                    },
                  };
                }}
                //   array.reduce((sum, obj) => sum + obj[field], 0) / array.length;
                //  defaultCenter={calculatedUsers[0] ? { lat: (calculatedUsers.reduce((sum,obj) => sum+obj.lat,0) / calculatedUsers.length), lng: (calculatedUsers.reduce((sum,obj) => sum+obj.lng,0) / calculatedUsers.length) } : { lat: 36.8969, lng: 30.7133 }}
                center={
                  users?.length
                    ? {
                        lat:
                          (users.reduce((sum, obj) => sum + obj["lat"], 0) + school.location.lat) / (users.length + 1),
                        lng:
                          (users.reduce((sum, obj) => sum + obj["lng"], 0) + school.location.lng) / (users.length + 1),
                      }
                    : { lat: school.location.lat, lng: school.location.lng }
                }
                defaultZoom={12}
              >
                {calculatedUsers.map((person, index) => {
                  return (
                    <Marker
                      Icon={RoomIcon}
                      lat={person.lat}
                      lng={person.lng}
                      key={person.id}
                      info={index + 1 + ". " + person.name + " - " + person?.polylineLabel}
                      initialShow={true}
                      alwaysBlue
                    />
                  );
                })}

                {formStateKarsilastirma?.inputs?.otherService?.value &&
                  otherServices
                    .find((service) => service.id === formStateKarsilastirma?.inputs?.otherService?.value)
                    ?.users.map((person, index) => {
                      return (
                        <Marker
                          Icon={RoomIcon}
                          lat={person.lat}
                          lng={person.lng}
                          key={person.id}
                          info={
                            otherServices.find(
                              (service) => service.id === formStateKarsilastirma?.inputs?.otherService?.value
                            ).name +
                            ". " +
                            (index + 1) +
                            ". " +
                            person.name
                          }
                          alwaysShowMarker={true}
                          alwaysBlue
                        />
                      );
                    })}

                <Marker
                  Icon={RoomIcon}
                  lat={school.location.lat}
                  lng={school.location.lng}
                  key={school.id}
                  info={school.name + " - " + destinationTime}
                  alwaysShowMarker={true}
                  alwaysBlue
                />
              </GoogleMapReact>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vehicle;
